import { markRaw } from 'vue'

/**
 * Sections registered by plugins to appear on the admin settings page,
 * alongside the schema-based settings sections.
 *
 * Follows the same pattern as src/sidenav/composables.js useModifySidenav()
 */
const sections = []

/**
 * Register a section on the instance admin settings page.
 * Used for plugins. Call it in your plugin setup() function.
 *
 * The section appears as an extra tab at /admin/settings/<name>,
 * rendering the given component (only accessible to instance admins,
 * like the rest of the settings page).
 *
 * @param section {{ name: string, label: string, component: Object }}
 */
export function useAddAdminSettingsSection (section) {
  if (sections.some(entry => entry.name === section.name)) return
  sections.push({ ...section, component: markRaw(section.component) })
}

export function useAdminSettingsSections () {
  return sections
}

/**
 * Prevents ending up with multiple registered plugin sections
 * after hot reloading in dev
 */
export function useResetAdminSettingsSections () {
  sections.length = 0
}
